import i from 'icepick'

const initialState = {
  billingAccounts: [],
  paymentTerms: [],
  billAttachments: [],
  bills: [],
  payments: [],
  paymentsLoading: false,
  payLoading: false,
  billsLoading: false,
  createLoading: false,
  getLoading: false,
  updateLoading: false,
  setupIntent: undefined,
  setupIntentLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'BILLING/GET_PAYMENT_TERMS_PENDING':
      return i.assoc(state, 'getLoading', true)
    case 'BILLING/GET_PAYMENT_TERMS_REJECTED':
      return i.assoc(state, 'getLoading', false)
    case 'BILLING/GET_PAYMENT_TERMS_FULFILLED':
      return i
        .chain(state)
        .assoc('paymentTerms', action.payload.data)
        .assoc('getLoading', false)
        .value()

    case 'BILLING/GET_BILL_ATTACHMENTS_PENDING':
      return i.assoc(state, 'getLoading', true)
    case 'BILLING/GET_BILL_ATTACHMENTS_REJECTED':
      return i.assoc(state, 'getLoading', false)
    case 'BILLING/GET_BILL_ATTACHMENTS_FULFILLED':
      return i
        .chain(state)
        .assoc('billAttachments', action.payload.data)
        .assoc('getLoading', false)
        .value()

    case 'BILLING/GET_BILLING_ACCOUNTS_PENDING':
      return i.assoc(state, 'getLoading', true)
    case 'BILLING/GET_BILLING_ACCOUNTS_REJECTED':
      return i.assoc(state, 'getLoading', false)
    case 'BILLING/GET_BILLING_ACCOUNTS_FULFILLED':
      return i
        .chain(state)
        .assoc('billingAccounts', action.payload.data)
        .assoc('getLoading', false)
        .value()

    case 'BILLING/GET_PAYMENTS_PENDING':
      return i.assoc(state, 'paymentsLoading', true)
    case 'BILLING/GET_PAYMENTS_REJECTED':
      return i.assoc(state, 'paymentsLoading', false)
    case 'BILLING/GET_PAYMENTS_FULFILLED':
      return i
        .chain(state)
        .assoc('payments', action.payload.data)
        .assoc('paymentsLoading', false)
        .value()

    case 'BILLING/GET_BILLING_ACCOUNT_PENDING':
      return i.assoc(state, 'getLoading', true)
    case 'BILLING/GET_BILLING_ACCOUNT_REJECTED':
      return i.assoc(state, 'getLoading', false)
    case 'BILLING/GET_BILLING_ACCOUNT_FULFILLED':
      return i
        .chain(state)
        .updateIn(['billingAccounts'], billingAccounts => {
          const billingAccountIndex = billingAccounts.findIndex(
            account => account.ban === action.payload.data.ban
          )
          return billingAccountIndex === -1
            ? i.push(billingAccounts, action.payload.data)
            : i.assocIn(billingAccounts, [billingAccountIndex], action.payload.data)
        })
        .assoc('getLoading', false)
        .value()

    case 'BILLING/CREATE_BILLING_ACCOUNT_PENDING':
      return i.assoc(state, 'createLoading', true)
    case 'BILLING/GREATE_BILLING_ACCOUNT_REJECTED':
      return i.assoc(state, 'createLoading', false)
    case 'BILLING/CREATE_BILLING_ACCOUNT_FULFILLED':
      return i
        .chain(state)
        .updateIn(['billingAccounts'], billingAccounts =>
          i.push(billingAccounts, action.payload.data)
        )
        .assoc('createLoading', false)
        .value()

    case 'BILLING/UPDATE_BILLING_ACCOUNT_PENDING':
      return i.assoc(state, 'updateLoading', true)
    case 'BILLING/UPDATE_BILLING_ACCOUNT_REJECTED':
      return i.assoc(state, 'updateLoading', false)
    case 'BILLING/UPDATE_BILLING_ACCOUNT_FULFILLED':
      return i
        .chain(state)
        .updateIn(['billingAccounts'], billingAccounts => {
          const billingAccountIndex = billingAccounts.findIndex(
            account => account.ban === action.payload.data.ban
          )
          return i.assocIn(billingAccounts, [billingAccountIndex], action.payload.data)
        })
        .assoc('updateLoading', false)
        .value()

    case 'BILLING/ADD_CREDIT_CARD_REJECTED':
      return i.assoc(state, 'creditCardError', action.payload.data)
    case 'BILLING/ADD_CREDIT_CARD_FULFILLED':
      return i
        .chain(state)
        .assoc(state, 'creditCardError', '')
        .updateIn(['billingAccounts'], billingAccounts => {
          const billingAccountIndex = billingAccounts.findIndex(
            account => account.ban === action.payload.data.ban
          )
          return billingAccountIndex === -1
            ? i.push(billingAccounts, action.payload.data)
            : i.assocIn(billingAccounts, [billingAccountIndex], action.payload.data)
        })
        .value()

    case 'BILLING/GET_BILLS_PENDING':
      return i.assoc(state, 'billsLoading', true)
    case 'BILLING/GET_BILLS_REJECTED':
      return i.assoc(state, 'billsLoading', false)
    case 'BILLING/GET_BILLS_FULFILLED':
      return i
        .chain(state)
        .assoc('bills', action.payload.data)
        .assoc('billsLoading', false)
        .value()

    case 'BILLING/PAY_BILL_PENDING':
      return i.assoc(state, 'payLoading', true)
    case 'BILLING/PAY_BILL_REJECTED':
      return i.assoc(state, 'payLoading', false)
    case 'BILLING/PAY_BILL_FULFILLED':
      return i.assoc(state, 'payLoading', false)

    case 'BILLING/SETUP_BANK_ACCOUNT_PENDING':
      return i.assoc(state, 'setupIntentLoading', true)
    case 'BILLING/SETUP_BANK_ACCOUNT_REJECTED':
      return i.assoc(state, 'setupIntentLoading', false)
    case 'BILLING/SETUP_BANK_ACCOUNT_FULFILLED':
      return i
        .chain(state)
        .assoc('setupIntent', action.payload.data)
        .assoc('setupIntentLoading', false)
        .value()

    case 'BILLING/UPDATE_BILLING_ACCOUNT_BANK_ACCOUNT_PENDING':
      return i.assoc(state, 'updateLoading', true)
    case 'BILLING/UPDATE_BILLING_ACCOUNT_BANK_ACCOUNT_REJECTED':
      return i.assoc(state, 'updateLoading', false)
    case 'BILLING/UPDATE_BILLING_ACCOUNT_BANK_ACCOUNT_FULFILLED':
      return i
        .chain(state)
        .updateIn(['billingAccounts'], billingAccounts => {
          const billingAccountIndex = billingAccounts.findIndex(
            account => account.ban === action.payload.data.ban
          )
          return i.assocIn(billingAccounts, [billingAccountIndex], action.payload.data)
        })
        .assoc('updateLoading', false)
        .value()

    case 'BILLING/UPDATE_BILLING_ACCOUNT_CREDIT_CARD_PENDING':
      return i.assoc(state, 'updateLoading', true)
    case 'BILLING/UPDATE_BILLING_ACCOUNT_CREDIT_CARD_REJECTED':
      return i.assoc(state, 'updateLoading', false)
    case 'BILLING/UPDATE_BILLING_ACCOUNT_CREDIT_CARD_FULFILLED':
      return i
        .chain(state)
        .updateIn(['billingAccounts'], billingAccounts => {
          const billingAccountIndex = billingAccounts.findIndex(
            account => account.ban === action.payload.data.ban
          )
          return i.assocIn(billingAccounts, [billingAccountIndex], action.payload.data)
        })
        .assoc('updateLoading', false)
        .value()

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/Billing.reducer.js